import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ResetPasswordView  from "./ResetPasswordView"

export class ResetPassword extends Component {
  static propTypes = {
    login: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <ResetPasswordView 
      resetPassword={this.props.actions.resetPassword}
      resetPasswordLoading={this.props.login.resetPasswordLoading}
      setResetPasswordLoading={this.props.actions.setResetPasswordLoading}
      />
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPassword);



// WEBPACK FOOTER //
// ./src/features/login/ResetPassword.js